module.exports = __webpack_public_path__ + "static/img/icon_bell.a9597b85.svg";